export default {"src":"/_next/static/media/arrow-left.6bae2615.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};